<template>
	<div class="userbg" v-loading="loading" :element-loading-text="$t('bc.bc_52')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<infoview :tabs="1"></infoview>
		<div class="userinfobg">
			<div class="userinfotop">
				<p>{{$t('UserInfo.UserInfo_1')}}</p>
				<span>{{$t('UserInfo.UserInfo_2')}}</span>
			</div>
			<div class="userinfoitem">
				<el-form :model="form" :rules="rules" ref="forms" label-width="38%">
					<el-form-item :label="$t('UserInfo.UserInfo_3')">
						{{form.email}}
					</el-form-item>
					<el-form-item :label="$t('UserInfo.UserInfo_4')" prop="tel">
						<el-input v-model="form.tel"></el-input>
					</el-form-item>
					<el-form-item :label="$t('UserInfo.UserInfo_13')">
						<!-- 已绑定 -->
						<!-- form.xycardshow = 1时为一绑定信用卡 -->
						<div class="userbind" v-if="form.xycardshow == 1">
							<span>{{$t('UserInfo.UserInfo_14')}}</span>
							<el-button type="info" @click="openpopshow()">{{$t('UserInfo.UserInfo_16')}}</el-button>
						</div>
						<!-- 未绑定 -->
						<div class="userbind" v-else>
							<span>{{$t('UserInfo.UserInfo_15')}}</span>
							<el-button type="info" @click="openpopshow()">{{$t('UserInfo.UserInfo_17')}}</el-button>
						</div>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item :label="$t('UserInfo.UserInfo_5')" prop="firstname">
						<el-input v-model="form.firstname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('UserInfo.UserInfo_6')" prop="secondname">
						<el-input v-model="form.secondname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('UserInfo.UserInfo_7')" prop="cardname">
						<el-radio-group v-model="form.cardname">
							<el-radio style=" white-space:normal;" :label="item.INIKEY02" v-for="(item,index) in KKDT"
								:key="item.INIKEY02">{{item.INIVALUE}}</el-radio>
							<!-- <el-radio style=" white-space:normal;" :label="$t('ReserveCar.ReserveCar_22')"></el-radio>
							<el-radio style=" white-space:normal;" :label="$t('ReserveCar.ReserveCar_23')"></el-radio>
							<el-radio style=" white-space:normal;" :label="$t('ReserveCar.ReserveCar_24')"></el-radio> -->
						</el-radio-group>
					</el-form-item>
					<!-- <el-form-item :label="$t('UserInfo.UserInfo_7')">
						<el-input v-model="form.cardname"></el-input>
					</el-form-item> -->
					<el-form-item :label="$t('UserInfo.UserInfo_8')" prop="fcardname">
						<el-input v-model="form.fcardname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('UserInfo.UserInfo_9')" prop="birthday">
						<!-- <el-input v-model="form.birthday"></el-input> -->
						<el-col :span="17">
							<el-date-picker type="date" :clearable="false" placeholder="" v-model="form.birthday"
								:picker-options="pickerOptions" style="width: 100%;">
							</el-date-picker>
						</el-col>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item :label="$t('UserInfo.UserInfo_10')" prop="jjname">
						<el-input v-model="form.jjname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('UserInfo.UserInfo_11')" prop="jjtel">
						<el-input v-model="form.jjtel"></el-input>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item>
						<el-button type="info" @click="upduser">{{$t('UserInfo.UserInfo_12')}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>


		<!-- 信用卡 -->
		<div class="carlogin" v-show="popshow">
			<div class="carloginitem">
				<img src="@/assets/default/close.png" alt="" @click="closepopshow()">
				<div class="userpoptop" v-if="form.xycardshow == 1">
					{{$t('UserInfo.UserInfo_18')}}
					<el-divider></el-divider>
				</div>
				<div class="userpoptop" v-else>
					{{$t('UserInfo.UserInfo_17')}}
					<el-divider></el-divider>
				</div>
				<div class="carloginlist">
					<el-form ref="cardform" :model="form" :rules="rules" label-width="35%">
						<el-form-item :label="$t('ReserveCar.ReserveCar_27')">
							<el-input v-model="form.fhem" placeholder="00000000"></el-input>
						</el-form-item>
						<el-form-item :label="$t('ReserveCar.ReserveCar_28')">
							<el-input v-model="form.poptel" placeholder="000"></el-input>
						</el-form-item>
						<el-form-item :label="$t('ReserveCar.ReserveCar_29')">
							<div class="row cdcard">
								<el-form-item prop="waymonth">
									<el-input v-model="form.waymonth" placeholder="01"
										style="width:80px;margin-right:10px" max="12"
										onkeyup="this.value=this.value.replace(/[^\d]/g,'') ">
									</el-input>
								</el-form-item> / <el-form-item>
									<el-input v-model="form.wayyear" placeholder="24"
										style="width:80px;;margin-left:10px"
										onkeyup="this.value=this.value.replace(/[^\d]/g,'') "></el-input>
								</el-form-item>
							</div>

						</el-form-item>
						<el-form-item :label="$t('ReserveCar.ReserveCar_30')">
							<el-input v-model="form.popfirstname" placeholder="TARO"></el-input>
						</el-form-item>
						<el-form-item :label="$t('ReserveCar.ReserveCar_31')">
							<el-input v-model="form.popsecondname" placeholder="YAMADA"></el-input>
						</el-form-item>
						<el-form-item :label="$t('ReserveCar.ReserveCar_32')">
							<el-input v-model="form.popcard" placeholder="1234＠5678.com"></el-input>
						</el-form-item>
						<el-form-item :label="$t('ReserveCar.ReserveCar_33')">
							<el-input v-model="form.popfh" placeholder="090-1234-5678"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" @click="aSaveCard">{{$t('UserInfo.UserInfo_12')}}</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import infoview from '../components/home/info/infoview.vue'

	export default {
		inject: ['reload'],
		name: 'userinfo',
		components: {
			infoview
		},
		data() {
			const validatetel = (rule, value, callback) => { //请输入电话号
				var tels = (/^[0-9]{8,13}$/)
				let isok = tels.test(value)
				console.log(isok)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_1')));
				} else if (!isok) {
					callback(new Error(this.$t('bc.bc_47')));
				} else {
					callback();
				}
			};
			const validatefirstname = (rule, value, callback) => { //请输入性
				if (value === '') {
					callback(new Error(this.$t('bc.bc_2')));
				} else {
					callback();
				}
			};
			const validatesecondname = (rule, value, callback) => { //请输入名
				if (value === '') {
					callback(new Error(this.$t('bc.bc_3')));
				} else {
					callback();
				}
			};
			const validatecardname = (rule, value, callback) => { //请输入身分証明書
				if (value === '') {
					callback(new Error(this.$t('bc.bc_4')));
				} else {
					callback();
				}
			};
			const validatefcardname = (rule, value, callback) => { //请输入身分証明書番号
				if (value === '') {
					callback(new Error(this.$t('bc.bc_5')));
				} else {
					callback();
				}
			};
			const validatebirthday = (rule, value, callback) => { //请选择生年月日
				// let myDate = new Date();
				// let stime = myDate.toLocaleDateString()
				// console.log(value.valueOf() > stime.valueOf())
				if (value === '') {
					callback(new Error(this.$t('bc.bc_6')));
					// } else if (value > stime) {
					// 	callback(new Error(this.$t('bc.bc_48')));
				} else {
					callback();
				}
			};
			const validatejjname = (rule, value, callback) => { //緊急連絡先氏名
				if (value === '') {
					callback(new Error(this.$t('bc.bc_7')));
				} else {
					callback();
				}
			};
			const validatejjtel = (rule, value, callback) => { //请输入緊急連絡先電話番号
				var tels = (/^[0-9]{8,13}$/)
				let isok = tels.test(value)
				if (value === '') {
					callback(new Error(this.$t('bc.bc_8')));
				} else if (!isok) {
					callback(new Error(this.$t('bc.bc_47')));
				} else {
					callback();
				}
			};
			// const validatefhem = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_26')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// const validatepoptel = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_27')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			const validatewaymonth = (rule, value, callback) => {
				if (value != '') {
					if (value > 12 || value < 1) {
						callback(new Error(this.$t('bc.bc_43')));
					}
					// callback(new Error(this.$t('bc.bc_28')));
				} else {
					callback();
				}
				callback();
			};
			// const validatewayyear = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_29')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// const validatepopfirstname = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_45')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// const validatepopsecondname = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_44')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// const validatepopcard = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error(this.$t('Register.Register_lbl12')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// const validatepopfh = (rule, value, callback) => {
			// 	var tels = (/^[0-9]{8,13}$/)
			// 	let isok = tels.test(value)
			// 	console.log(isok)
			// 	if (value === '') {
			// 		callback(new Error(this.$t('bc.bc_1')));
			// 	} else if (!isok) {
			// 		callback(new Error(this.$t('bc.bc_47')));
			// 	} else {
			// 		callback();
			// 	}
			// };
			let secondOfDay = 1000 * 60 * 60 * 24;
			let _minDate = 0;
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				loading: false,
				form: {
					email: '',
					tel: '',
					firstname: '',
					secondname: '',
					cardname: '0',
					fcardname: '',
					birthday: '',
					jjname: '',
					jjtel: '',
					xycardshow: 0,
					fhem: '',
					poptel: '',
					waymonth: '',
					wayyear: '',
					popfirstname: '',
					popsecondname: '',
					popcard: '',
					popfh: ''
				},
				rules: {
					tel: [{ //提示请输入手机号
						trigger: ['blur', 'change'],
						validator: validatetel
					}],
					firstname: [{ //提示输入性
						trigger: ['blur', 'change'],
						validator: validatefirstname
					}],
					secondname: [{ //提示输入名
						trigger: ['blur', 'change'],
						validator: validatesecondname
					}],
					cardname: [{
						trigger: ['blur', 'change'],
						validator: validatecardname
					}],
					fcardname: [{
						trigger: ['blur', 'change'],
						validator: validatefcardname
					}],
					birthday: [{
						trigger: ['blur', 'change'],
						validator: validatebirthday
					}],
					jjname: [{
						trigger: ['blur', 'change'],
						validator: validatejjname
					}],
					jjtel: [{
						trigger: ['blur', 'change'],
						validator: validatejjtel
					}],
					// 信用卡
					// fhem: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatefhem
					// }],
					// poptel: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatepoptel
					// }],
					waymonth: [{
						trigger: ['blur', 'change'],
						validator: validatewaymonth
					}],
					// wayyear: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatewayyear
					// }],
					// popfirstname: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatepopfirstname
					// }],
					// popsecondname: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatepopsecondname
					// }],
					// popcard: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatepopcard
					// }],
					// popfh: [{
					// 	trigger: ['blur', 'change'],
					// 	validator: validatepopfh
					// }],
				},
				popshow: false,
				lang: 0,
				KKDT: [],
				radiokey: ''
			};
		},
		watch: {},
		computed: {},
		methods: {
			closepopshow() {
				this.popshow = false
				this.Move()
			},
			openpopshow() {
				this.popshow = true
				this.stopMove()
			}, //停止页面滚动
			stopMove() {
				// let m = function(e) {
				// 	e.preventDefault();
				// };
				document.body.style.overflow = 'hidden';
				// document.addEventListener("touchmove", m, {
				// 	passive: false
				// }); //禁止页面滑动
			},
			//开启页面滚动
			Move() {
				// let m = function(e) {
				// 	e.preventDefault();
				// };
				document.body.style.overflow = 'auto'; //出现滚动条
				// document.removeEventListener("touchmove", m, {
				// 	passive: true
				// });
			},
			// 获取身份证书
			GET_INI_LIST() {
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				} else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				} else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}

				this.$api.post(this.$config.GET_INI_LIST, {
						'sCOMID': '000',
						'sLNGCT': this.lang,
						'sKEY01': '10165'
					},
					// 请求成功
					success => {
						console.log(success)
						this.KKDT = success.KKDT
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			// 获取用户信息
			getuser() {
				this.$api.post(this.$config.Get_User, {
						'sMSTID': sessionStorage.getItem('log_mstid'),
					},
					// 请求成功
					success => {
						console.log(success)
						this.form.tel = success.KKDT[0].PBATELNO
						this.form.email = success.KKDT[0].PBAEMAIL
						this.form.firstname = success.KKDT[0].PBAFAMNM
						this.form.secondname = success.KKDT[0].PBAGIVNM
						this.form.birthday = success.KKDT[0].PBABITDT
						if (success.KKDT[0].PBACERTI) {
							this.form.cardname = success.KKDT[0].PBACERTI
						} else {
							this.form.cardname = '0'
						}
						this.form.fcardname = success.KKDT[0].PBACERID
						this.form.jjname = success.KKDT[0].PBAEMCNM
						this.form.jjtel = success.KKDT[0].PBAEMTEL
						// 信用卡
						this.form.fhem = success.KKDT[0].PBACADID
						this.form.poptel = success.KKDT[0].PBACACVV
						this.form.waymonth = success.KKDT[0].PBACAMON
						this.form.wayyear = success.KKDT[0].PBACAYER
						this.form.popfirstname = success.KKDT[0].PBACANAM
						this.form.popsecondname = success.KKDT[0].PBACAAME
						this.form.popcard = success.KKDT[0].PBACAEML
						this.form.popfh = success.KKDT[0].PBACATEL
						if (success.KKDT[0].PBACADID) {
							this.form.xycardshow = 1
						} else {
							this.form.xycardshow = 0
						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			// 修改用户信息
			upduser() {
				console.log(this.form.cardname)
				this.form.birthday = new Date(this.form.birthday)
				this.form.birthday = this.form.birthday.getFullYear() + '-' + (this.form.birthday.getMonth() + 1) + '-' +
					this.form.birthday.getDate()

				this.$refs.forms.validate((valid) => {
					if (valid) {
						this.loading = true
						this.$api.post(this.$config.Upd_User, {
								'sMSTID': sessionStorage.getItem('log_mstid'),
								'sTELNO': this.form.tel,
								'sFAMNM': this.form.firstname,
								'sGIVNM': this.form.secondname,
								'sBITDT': this.form.birthday,
								'sCERTI': this.form.cardname, //身份证书
								'sCERID': this.form.fcardname,
								'sEMCNM': this.form.jjname,
								'sEMTEL': this.form.jjtel,
								// 'sCADID': this.form.fhem,
								// 'sCACVV': this.form.poptel,
								// 'sCAMON': this.form.waymonth,
								// 'sCAYER': this.form.wayyear,
								// 'sCANAM': this.form.popfirstname,
								// 'sCAAME': this.form.popsecondname,
								// 'sCAEML': this.form.popcard,
								// 'sCATEL': this.form.popfh

							},
							// 请求成功
							success => {
								this.loading = false
								console.log(success)
								if (success.KKSTR == 'Y') {
									this.reload();
									this.$message.success(this.$t('UserInfo.UserInfo_25'));
								}
							},
							// 请求失败
							error => {
								console.log(error)
							}
						)
					} else {
						this.$message({
							message: this.$t('bc.bc_38'), //请求失败
							type: 'error'
						});
					}
				});
			},

			// 信用卡
			aSaveCard() {
				this.$refs.cardform.validate((valid) => {
					if (valid) {
						this.Move()
						this.loading = true
						this.$api.post(this.$config.SaveCard, {
								'sMSTID': sessionStorage.getItem('log_mstid'),
								'sCADID': this.form.fhem,
								'sCACVV': this.form.poptel,
								'sCAMON': this.form.waymonth,
								'sCAYER': this.form.wayyear,
								'sCANAM': this.form.popfirstname,
								'sCAAME': this.form.popsecondname,
								'sCAEML': this.form.popcard,
								'sCATEL': this.form.popfh
							},
							// 请求成功
							success => {
								this.loading = false
								console.log(success)
								if (success.KKSTR == 'Y') {
									this.reload();
									this.$message.success(this.$t('UserInfo.UserInfo_25'));
								}
							},
							// 请求失败
							error => {
								console.log(error)
							}
						)
					} else {
						this.$message({
							message: this.$t('bc.bc_54'), //请求失败
							type: 'error'
						});
					}
				});
			},
		},

		created() {

		},
		mounted() {
			this.Move()
			this.GET_INI_LIST()
			this.getuser()
		}
	}
</script>

<style scoped>
	@media only screen and (min-width:800px) {
		.userbg {
			width: 80%;
			margin: 0 auto;
			padding-top: 60px;
			display: flex;
			flex-direction: row;
		}

		.userinfotop>p {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
		}

		.userinfotop {

			margin-bottom: 45px;
		}

		/deep/ .el-form-item__label {
			text-align: center !important;
			font-size: 14px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			display: flex;
			align-items: center;
			height: 40px;
			line-height: 20px;
			justify-content: center;
		}

		.userbind>.el-button {
			padding: 10px 16px;
			font-size: 13px;
		}

		.carloginlist {
			padding: 20px 90px;
			width: 100%
		}

		/deep/ .carloginlist .el-form-item__label {
			text-align: left !important;
			font-size: 14px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			line-height: 20px;
			display: flex;
			align-items: center;
			height: 40px;
			justify-content: left;
		}

		.userpoptop {
			width: 90%;
			margin: 0 auto;
			padding-top: 24px;
			text-align: left;
			font-weight: bold;
			font-size: 20px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		}
	}

	@media only screen and (max-width:800px) {
		.userbg {
			width: 90%;
			margin: 0 auto;
			padding-top: 10px;
			display: block;
		}

		.userinfotop>p {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 20px;
		}

		.userinfotop {

			margin-bottom: 25px;
		}

		/deep/ .el-form-item__label {
			text-align: center !important;
			font-size: 12px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			display: flex;
			align-items: center;
			height: 40px;
			line-height: 20px;
			justify-content: center;
		}

		/deep/ .el-form-item {
			margin-bottom: 12px;
		}

		.userbind>.el-button {
			padding: 10px 12px;
			font-size: 12px;
		}

		.carloginlist {
			padding: 20px 60px;
			width: 100%
		}

		/deep/ .carloginlist .el-form-item__label {
			text-align: left !important;
			font-size: 12px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			line-height: 16px;
			display: flex;
			align-items: center;
			height: 40px;
			justify-content: left;
		}

		.userpoptop {
			width: 90%;
			margin: 0 auto;
			padding-top: 24px;
			text-align: left;
			font-weight: bold;
			font-size: 18px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		}
	}

	@media only screen and (max-width:500px) {

		.carloginlist {
			padding: 20px 20px;
			width: 100%
		}

		.userbind>.el-button {
			padding: 10px 12px;
			font-size: 10px;
		}
	}

	/* .row {
		display: flex;
		flex-direction: row;
	} */

	.userinfobg {
		width: 100%;
	}



	.userinfotop>span {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}

	.userinfoitem {
		width: 100%;
		box-sizing: border-box;
	}





	.el-form-item__content {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
	}

	.el-input {
		width: 70%;
	}

	.el-button--info {
		background-color: #000;
		border: #000000;
	}

	.el-button--info {
		background-color: #000;
		border: #000000;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.el-button {
		padding: 12px 40px;
	}

	.userbind {

		font-size: 14px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
	}

	.userbind>span {
		margin-right: 12px;
	}


	.carlogin {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(221, 221, 221, 0.8000);
		overflow: hidden;
		display: flex;
		align-items: center;
		/* text-align: center; */
		justify-content: center
	}

	.carloginitem {
		width: 640px;
		margin: 0 auto;
		border-radius: 6px;
		background-color: #fff;
	}


	.carloginitem>img {
		width: 22px;
		height: 48px;
		float: right;
		margin-right: 15px;
		cursor: pointer;
	}


	.carloginbox {
		width: 46%;
		margin: 0 auto;
		height: 50px;
		line-height: 50px;
		padding: 0 10px;
		box-sizing: border-box;
		margin-bottom: 15px
	}

	.carloginbox>img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 18px;
	}

	.carloginbox>p {
		width: calc(100% - 18px);
		font-size: 18px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}

	.userpoptop .el-divider--horizontal {
		margin: 0;
		margin-top: 18px;
	}

	.carloginlist .el-input {
		width: 90%;
	}

	/deep/ .el-radio-group {
		border: 1px solid #ddd;
		padding: 15px;
		box-sizing: border-box;
		line-height: 30px;
	}

	/deep/ .el-radio {
		width: 100%;
	}
</style>